export default __webpack_public_path__ + "static/media/004-B-transport.d82f0263.svg";